/**
 * Combined Listings Handler
 * Handles seamless product switching for combined listings using metaobjects
 */

class CombinedListings {
  constructor() {
    this.init();
  }

  init() {
    // Find all product pages with combined listing data
    const combinedListingData = document.querySelector('[id^="combined-listing-data-"]');

    if (!combinedListingData) {
      return;
    }

    try {
      this.data = JSON.parse(combinedListingData.textContent);

      if (!this.data.isCombinedListing) {
        return;
      }

      this.currentProductId = this.data.currentProductId;
      this.products = this.data.products;
      this.sectionId = combinedListingData.id.split('-').pop();

      this.bindEvents();
      this.initializeCurrentProduct();
    } catch (error) {
      console.error('Combined Listings: Failed to parse data', error);
    }
  }

  bindEvents() {
    // Prevent default behavior for combined listing options
    const eventTypes = ['click', 'change', 'input'];

    eventTypes.forEach((eventType) => {
      document.addEventListener(
        eventType,
        (e) => {
          // Check if this is a combined listing related element
          const isCombinedListingInput = e.target.classList.contains('combined-listing-option');
          const isCombinedListingLabel =
            e.target.tagName === 'LABEL' &&
            e.target.getAttribute('for') &&
            document.getElementById(e.target.getAttribute('for'))?.classList.contains('combined-listing-option');

          if (isCombinedListingInput || isCombinedListingLabel) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            if (eventType === 'click') {
              // Handle the product switch
              let input = isCombinedListingInput ? e.target : document.getElementById(e.target.getAttribute('for'));
              if (input && !input.disabled) {
                input.checked = true;
                this.handleProductSwitch(input);
              }
            }

            return false;
          }
        },
        true
      ); // Use capture phase
    });

    // Handle dropdown changes
    document.addEventListener('change', (e) => {
      if (e.target.closest('.product-form__input--dropdown') && e.target.querySelector('[data-product-id]')) {
        const selectedOption = e.target.selectedOptions[0];
        console.log('📝 Dropdown option selected:', selectedOption);
        if (selectedOption && selectedOption.dataset.productId) {
          this.handleProductSwitch(selectedOption);
        }
      }
    });
  }

  initializeCurrentProduct() {
    // Set up initial state
    this.currentProduct = this.products.find((p) => p.id == this.currentProductId);
  }

  handleProductSwitch(element) {
    const newProductId = parseInt(element.dataset.productId);

    if (newProductId === this.currentProductId) {
      return;
    }

    const newProduct = this.products.find((p) => p.id === newProductId);

    if (!newProduct) {
      return;
    }

    this.switchToProduct(newProduct);
  }

  preventFormSubmit(e) {
    e.preventDefault();
  }

  switchToProduct(newProduct) {
    // Navigate to the new product page
    window.location.href = newProduct.url;
  }

  updateImages(product) {
    console.log('📸 updateImages - looking for:', `#Slider-Gallery-${this.sectionId}`);

    // Update main product images
    const imageGallery = document.querySelector(`#Slider-Gallery-${this.sectionId}`);
    console.log('📸 Image gallery found:', imageGallery);
    console.log('📸 Product images count:', product.images.length);

    if (imageGallery && product.images.length > 0) {
      console.log('✅ Replacing image gallery...');
      this.replaceImageGallery(imageGallery, product);
    } else {
      console.log('❌ Cannot update images - gallery not found or no images');
    }

    // Update thumbnails
    const thumbnailGallery = document.querySelector(`#Slider-Thumbnails-${this.sectionId}`);
    console.log('📸 Thumbnail gallery found:', thumbnailGallery);

    if (thumbnailGallery && product.images.length > 0) {
      console.log('✅ Replacing thumbnail gallery...');
      this.replaceThumbnailGallery(thumbnailGallery, product);
    } else {
      console.log('❌ Cannot update thumbnails - gallery not found or no images');
    }
  }

  replaceImageGallery(gallery, product) {
    const newHTML = product.images
      .map(
        (image, index) => `
      <li id="Slide-${this.sectionId}-${index}" 
          class="product__media-item grid__item slider__slide${index === 0 ? ' is-active' : ''}"
          data-media-id="${this.sectionId}-${index}">
        <img src="${image.url}" 
             alt="${image.alt || product.title}" 
             width="${image.width}" 
             height="${image.height}"
             loading="${index === 0 ? 'eager' : 'lazy'}"
             class="global-media-settings">
      </li>
    `
      )
      .join('');

    gallery.innerHTML = newHTML;
  }

  replaceThumbnailGallery(gallery, product) {
    const newHTML = product.images
      .map(
        (image, index) => `
      <li id="Slide-Thumbnails-${this.sectionId}-${index}" 
          class="thumbnail-list__item slider__slide"
          data-target="${this.sectionId}-${index}">
        <button class="thumbnail global-media-settings" 
                ${index === 0 ? 'aria-current="true"' : ''}>
          <img src="${image.url}" 
               alt="${image.alt || product.title}" 
               width="104" 
               height="104"
               loading="lazy">
        </button>
      </li>
    `
      )
      .join('');

    gallery.innerHTML = newHTML;
  }

  updatePrice(product) {
    const priceElement = document.querySelector(`#price-${this.sectionId}`);
    if (!priceElement) return;

    const variant = product.variants[0]; // Use first variant for now
    if (!variant) return;

    let priceHTML = `<span class="price-item price-item--regular">${this.formatMoney(variant.price)}</span>`;

    if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
      priceHTML = `
        <span class="price-item price-item--sale">${this.formatMoney(variant.price)}</span>
        <s class="price-item price-item--regular">${this.formatMoney(variant.compareAtPrice)}</s>
      `;
    }

    priceElement.innerHTML = `<div class="price price--large">${priceHTML}</div>`;
  }

  updateTitle(product) {
    // Update page title
    document.title = product.title;

    // Update product title on page
    const titleElement = document.querySelector('.product__title h1');
    if (titleElement) {
      titleElement.textContent = product.title;
    }
  }

  updateInventory(product) {
    const inventoryElement = document.querySelector(`#Inventory-${this.sectionId}`);
    if (!inventoryElement) return;

    const variant = product.variants[0];
    if (!variant) return;

    // Update inventory display based on availability
    if (variant.available) {
      inventoryElement.innerHTML = `
        <span class="svg-wrapper" style="color: rgb(62, 214, 96)">
          <svg><!-- inventory icon --></svg>
        </span>
        In stock
      `;
      inventoryElement.classList.remove('visibility-hidden');
    } else {
      inventoryElement.innerHTML = `
        <span class="svg-wrapper" style="color: rgb(200, 200, 200)">
          <svg><!-- inventory icon --></svg>
        </span>
        Out of stock
      `;
      inventoryElement.classList.remove('visibility-hidden');
    }
  }

  updateSku(product) {
    const skuElement = document.querySelector(`#Sku-${this.sectionId}`);
    if (!skuElement) return;

    const variant = product.variants[0];
    if (variant && variant.sku) {
      skuElement.textContent = variant.sku;
      skuElement.classList.remove('visibility-hidden');
    } else {
      skuElement.classList.add('visibility-hidden');
    }
  }

  updateVariantPicker(product) {
    // Update regular variant options for the new product
    const variantSelects = document.querySelector(`#variant-selects-${this.sectionId}`);
    if (!variantSelects) return;

    // Update selected variant data
    const selectedVariantScript = variantSelects.querySelector('[data-selected-variant]');
    if (selectedVariantScript && product.variants[0]) {
      selectedVariantScript.textContent = JSON.stringify(product.variants[0]);
    }

    // If the product has multiple variants, we'd need to rebuild the variant picker
    // For now, we'll handle single-variant products
  }

  updateAddToCartButton(product) {
    const addToCartButton = document.querySelector(`[form="product-form-${this.sectionId}"] button[type="submit"]`);
    if (!addToCartButton) return;

    const variant = product.variants[0];
    if (!variant) return;

    // Update hidden variant ID input
    const variantInput = document.querySelector(`[form="product-form-${this.sectionId}"] input[name="id"]`);
    if (variantInput) {
      variantInput.value = variant.id;
    }

    // Update button state
    if (variant.available) {
      addToCartButton.disabled = false;
      addToCartButton.textContent = 'Add to cart';
    } else {
      addToCartButton.disabled = true;
      addToCartButton.textContent = 'Sold out';
    }
  }

  updateURL(product) {
    // Update browser URL without page reload
    const newURL = `${window.location.origin}${product.url}`;
    console.log('🔗 Updating URL to:', newURL);
    window.history.replaceState({ productId: product.id }, product.title, newURL);
    console.log('✅ URL updated successfully, no reload should occur');
  }

  updateSelectedValue(product) {
    // Update the selected value display
    const selectedValueSpan = document.querySelector('[data-selected-value]');
    if (selectedValueSpan) {
      selectedValueSpan.textContent = product.optionValue;
    }
  }

  showLoading() {
    document.body.classList.add('combined-listings-loading');
  }

  hideLoading() {
    document.body.classList.remove('combined-listings-loading');
  }

  formatMoney(cents) {
    // Simple money formatting - you might want to use Shopify's money filters
    return `$${(cents / 100).toFixed(2)}`;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new CombinedListings());
} else {
  new CombinedListings();
}
